import { deleteAssistanceReport } from "./deleteAssistanceReport";
import { getAssistanceReport } from "./getAssistanceReport";
import { postAssistanceReport } from "./postAssistanceReport";

export const assistanceReportApi = {
  getAssistanceReport,
  postAssistanceReport,
  deleteAssistanceReport
};
